/**
 * GroupInfoSection Component
 * 그룹코드 정보 입력 섹션
 */
import React from 'react';
import FormInput from '@/shared/components/forms/FormInput';
import { GroupFormData } from '../utils/commonCodeCreateUtils';

interface GroupInfoSectionProps {
    formData: GroupFormData;
    onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
}

const GroupInfoSection: React.FC<GroupInfoSectionProps> = ({ formData, onChange }) => {
    return (
        <div className="form-section">
            <div className="form-section-header">
                <h2 className="form-section-title">그룹코드 정보</h2>
            </div>
            <div className="form-section-body">
                <div className="form-row form-row-three">
                    <div className="form-group">
                        <FormInput
                            id="grpCode"
                            name="grpCode"
                            type="text"
                            label="그룹코드"
                            value={formData.grpCode}
                            onChange={onChange}
                            placeholder="그룹코드를 입력하세요"
                            required
                        />
                    </div>

                    <div className="form-group">
                        <FormInput
                            id="grpName"
                            name="grpName"
                            type="text"
                            label="그룹명"
                            value={formData.grpName}
                            onChange={onChange}
                            placeholder="그룹명을 입력하세요"
                            required
                        />
                    </div>

                    <div className="form-group">
                        <FormInput
                            id="grpVal"
                            name="grpVal"
                            type="text"
                            label="그룹값"
                            value={formData.grpVal}
                            onChange={onChange}
                            placeholder="그룹값을 입력하세요"
                        />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default GroupInfoSection;
